import React from 'react'
import ReactGA from 'react-ga'
import { Link } from 'react-router-dom'
import ym from 'react-yandex-metrika'

import { getColorByStationName, pluralize } from '../../helpers/common'
import { CarIcon } from '../icons/CarIcon'
import { FlashIcon } from '../icons/FlashIcon'
import { HoverIcon } from '../icons/HoverIcon'
import { WalkMan } from '../icons/WalkMan'
import styles from './NewProjectCard.module.scss'
import { NewProjectCardTypes } from './NewProjectCard.types'

export const NewProjectCard = ({ data }: NewProjectCardTypes) => {
  const {
    UF_BUILDING_NAME,
    LOCATION,
    CNT,
    UF_IMAGE,
    PRICE_PER_SQUARE,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    url_code,
  } = data

  return (
    <Link
      to={`/project/${url_code}`}
      onClick={() => {
        ReactGA.ga(
          'send',
          'event',
          'client link',
          'projects click main list',
          UF_BUILDING_NAME
        )
        ReactGA.ga('rbcspec.send', 'event', 'client link', 'click')
        ym('reachGoal', 'projects click', {
          'projects click main list': UF_BUILDING_NAME,
        })
      }}
    >
      <div className={styles.NewProjectCard}>
        <h3>{UF_BUILDING_NAME}</h3>

        <div className={styles.metro}>
          {LOCATION?.UF_METRO_NAME?.length && (
            <>
              <div
                className={styles.metroColor}
                style={{
                  background: getColorByStationName(LOCATION?.UF_METRO_NAME),
                }}
              />
              <p>{LOCATION.UF_METRO_NAME}</p>
              {Number(LOCATION.UF_METRO_TIME_ON_FOOT) > 0 && (
                <>
                  <WalkMan />
                  <p>{LOCATION.UF_METRO_TIME_ON_FOOT} мин</p>
                </>
              )}

              {Number(LOCATION.UF_METRO_TIME_ON_TRANSPORT) > 0 &&
                Number(LOCATION.UF_METRO_TIME_ON_FOOT) <= 0 && (
                  <>
                    <CarIcon />
                    <p>{LOCATION.UF_METRO_TIME_ON_TRANSPORT} мин</p>
                  </>
                )}
            </>
          )}
        </div>

        <div className={styles.img}>
          <div className={styles.hoverIcon}>
            <HoverIcon />
          </div>
          {CNT <= 50 && (
            <div className={styles.flatsBlock}>
              <FlashIcon />
              <p>
                Осталось {pluralize(CNT, 'квартира', 'квартиры', 'квартир')}
              </p>
            </div>
          )}
          <img src={UF_IMAGE} alt={UF_BUILDING_NAME} />
        </div>
        <span className={styles.bottom}>
          От {PRICE_PER_SQUARE.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} ₽ за м²
        </span>
      </div>
    </Link>
  )
}
